import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Manage translations' | translate }}</h2>
        </div>
        <div class="modal-body form">
            <div style="margin-top:20px; position:relative; height:200px" ng-if="vm.loading">
                <div class="loader02">
                {{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}
                </div>
            </div>
            <form-wrapper form="vm.form">
            <div style="overflow-x:auto;">
                <table class="data01" style="padding: 5px;">
                    <tr>
                        <th>{{ 'general.Label ' | translate }}</th>
                        <th>{{ vm.defaultLanguage }} <small>({{ 'translation.default' | translate}})</small></th>
                        <th ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <label><input type="checkbox" ng-model="vm.languages[code]"
                            ng-click="vm.toggleCheckbox(code)"> {{ code }}</label>
                        </th>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Course name' | translate }}*</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <input ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].name" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.courseI18ns[code].name">
                                <div class="items">
                                    <input ng-model="vm.form.model.courseI18ns[code].name" ng-if="value" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Course description' | translate }}</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseI18ns[vm.defaultLanguage].description">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].description"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.courseI18ns[vm.defaultLanguage].description">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="vm.form.model.courseI18ns[code].description"
                                        ng-if="value"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Course planning recommendation' | translate }}</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseI18ns[vm.defaultLanguage].planningRecommendation">
                                <div class="items">
                                    <textarea ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].planningRecommendation"
                                    type="text" class="form-control"></textarea>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.courseI18ns[vm.defaultLanguage].planningRecommendation">
                                <div class="items">
                                    <textarea ng-model="vm.form.model.courseI18ns[code].planningRecommendation" ng-if="value"
                                    type="text" class="form-control"></textarea>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr class="subheading02" ng-repeat-start="(versionKey,version) in vm.form.model.courseVersions" ng-if="!version.isArchived">
                        <td >{{ 'version.Version name' | translate }}</td>
                        <td colspan="{{ vm.languages.length }}">{{ version.name }} <span ng-if="version.isArchived">({{ 'version.Archived' | translate }})</span></td>
                    </tr>
                    <tr class="separated" ng-repeat-start="(key, training) in version.courseTrainings" ng-if="!version.isArchived">
                        <td>{{ 'translation.Training name' | translate }}*</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <input ng-model="training.courseTrainingI18ns[vm.defaultLanguage].name"
                                     class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-if="!version.isArchived">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[code].name">
                                <div class="items">
                                    <input ng-model="training.courseTrainingI18ns[code].name"
                                    ng-if="value" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-if="!version.isArchived">
                        <td>{{ 'translation.Training description' | translate }}</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[vm.defaultLanguage].description">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="training.courseTrainingI18ns[vm.defaultLanguage].description"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[code].description">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="training.courseTrainingI18ns[code].description"
                                        ng-if="value"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-if="training.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK && !version.isArchived">
                        <td>{{ 'translation.Training feedback title' | translate }}</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[vm.defaultLanguage].feedbackTitle">
                                <div class="items">
                                    <input ng-model="training.courseTrainingI18ns[vm.defaultLanguage].feedbackTitle"
                                     class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[code].feedbackTitle">
                                <div class="items">
                                    <input ng-model="training.courseTrainingI18ns[code].feedbackTitle"
                                     ng-if="value" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-if="training.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK">
                        <td>{{ 'translation.Training feedback introduction' | translate }}</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[vm.defaultLanguage].feedbackIntroduction">
                                <div class="items">
                                   <ng-ckeditor
                                        ng-model="training.courseTrainingI18ns[vm.defaultLanguage].feedbackIntroduction"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.courseVersions[versionKey].courseTrainings[key].courseTrainingI18ns[code].feedbackIntroduction">
                                <div class="items">
                                   <ng-ckeditor
                                        ng-model="training.courseTrainingI18ns[code].feedbackIntroduction"
                                        ng-if="value"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-repeat-end ng-hide="true"></tr>
                    <tr ng-repeat-end ng-hide="true"></tr>
                </table>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
        <ul class="actions01">
            <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $translate, lodash, COURSE_TRAINING_TYPE_ENUM, TokenService, ModalService, FormFactory,
                 CkEditorService, CourseService) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.FormFactory = FormFactory;
        this.CourseService = CourseService;
        this.CkEditorService = CkEditorService;
        this.loading = false;
    }

    $onInit () {
        const { lodash, course } = this;

        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();

        // this holds all available language codes as key and whether they are activated as value
        this.languages = {};
        this.learndashCourses = {};

        lodash.forEach(companySupportedLanguages, (code) => {
            this.languages[code] = lodash.has(course.courseI18ns, code);
            if (!this.languages[code]) {
                lodash.forEach(course.courseVersions, version => {
                    if (lodash.isArray(version.courseTrainings)) {
                        lodash.forEach(version.courseTrainings, training => {
                            if (!this.languages[code]) {
                                this.languages[code] = this.lodash.has(training.courseTrainingI18ns, code);
                            }
                        });
                    }
                });
            }
        });

        // transform form ids into correct format for test trainings which have multiple forms
        lodash.forEach(course.courseVersions, version => {
            if (lodash.isArray(version.courseTrainings)) {
                lodash.forEach(version.courseTrainings, training => {
                    if (lodash.isArray(training.forms)) {
                        training.formIds = training.forms.map(trainingForm => trainingForm.id);
                    }
                });
            }
        });
        this.form = this.FormFactory.create(course, model => model.$update({
            id: model.id,
            expand: 'fields,courseTargetsWithValue,courseTrainings,courseTrainings.scormTrainings,' +
                'courseTrainings.materials,courseTrainings.materials.languages,courseTrainings.materials.chapters.chapterI18ns,' +
                'courseTrainings.materials.chapters.section.sectionI18ns,' +
                'courseTrainingsActiveI18n,activeI18n,courseI18ns,courseTrainingI18ns,courseVersions,sites'
        }));

        this.ckconfig = this.ckconfig = {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'links', items: ['Link', 'Unlink'] }
            ]
        };
    }

    toggleCheckbox (code) {
        const confirmMessage = this.$translate.instant('translations.Are you sure you would like to remove this translation?');
        if (!this.languages[code]) {
            // leave checkbox checked
            this.languages[code] = !this.languages[code];
            this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                // uncheck if confirmed
                this.languages[code] = !this.languages[code];
                this.clearErrors(code);
            });
        }
    }

    clearErrors (code) {
        // if language is disabled, make sure no error messages are left in ui
        if (this.lodash.has(this.form.errors.courseI18ns, code)) {
            delete this.form.errors.courseI18ns[code];
        }

        if (this.lodash.has(this.form.errors, 'courseVersions')) {
            this.lodash.forEach(this.form.errors.courseVersions, (version) => {
                if (this.lodash.has(version, 'courseTrainings')) {
                    this.lodash.forEach(version.courseTrainings, (training) => {
                        if (this.lodash.has(training.courseTrainingI18ns, code)) {
                            delete training.courseTrainingI18ns[code];
                        }
                    });
                }
            });
        }
    }

    beforeSave () {
        // we need to set expirationMonths as 0 because form 0 equals NULL in db
        if (this.form.model.expirationMonths === null) {
            this.form.model.expirationMonths = 0;
        }
        // form fields are supposed to be ids
        this.form.model.fields = this.course.fields.map((val) => val.id);
        this.form.model.courseSiteIds = this.course.sites.map(site => (site.id));

        this.handleTranslations();
    }

    handleTranslations () {
        this.lodash.forEach(this.languages, (isActive, code) => {
            if (!isActive) {
                this.deleteDisabledI18ns(code);
            }
        });
    }

    deleteDisabledI18ns (code) {
        // if course has current language, delete it
        if (this.lodash.has(this.form.model.courseI18ns, code)) {
            delete this.form.model.courseI18ns[code];
        }

        this.lodash.forEach(this.form.model.courseVersions, (version) => {
            this.lodash.forEach(version.courseTrainings, (training) => {
                // if training has current language, delete it
                if (this.lodash.has(training.courseTrainingI18ns, code)) {
                    delete training.courseTrainingI18ns[code];
                }
            });
        });
    }

    save () {
        this.loading = true;
        this.beforeSave();
        this.form.save()
            // todo:this hard reload is currently needed for data in child states to refresh (general + trainings tab)
            .then((updatedModel) => {
                this.CourseService.nestCompositeModels(updatedModel);
                this.form.model = updatedModel;
                window.location.reload(true);
            }).catch(() => {
                this.loading = false;
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/translation/index.js